import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Card } from '@liquid-spirit/ui-web';
import DetailEmptyState from '../../components/common/DetailEmptyState';

// Route errorElement for /activities/:activityId. If anything in the activity
// detail subtree throws (e.g. the activity is no longer available and the data
// is missing/partial in a way a render can't recover from), show this friendly
// "not available" page in place of the detail — and in place of the generic
// app-wide "Something went wrong" route error.
const ActivityUnavailable = () => {
  const navigate = useNavigate();
  return (
    <Box className="activity-details-container">
      <Card className="activity-details-card activity-details-empty-state-card">
        <DetailEmptyState
          contextLabel="Activity Details"
          title="This activity is no longer available"
          message="It may have been removed, unpublished, or the link you opened is no longer valid."
          actionLabel="Browse Activities"
          onAction={() => navigate('/discover')}
        />
      </Card>
    </Box>
  );
};

export default ActivityUnavailable;
